import React, { Component } from "react";

import {
  DKLabel,
  DKButton,
  DKIcons,
  DKIcon,
  DKListPicker,
  DKSpinner,
} from "deskera-ui-library";
import { AUTOMATION_TRIGGERS } from "../AutomationConstants";
import {
  COLUMN_CODE,
  TableManger,
  TABLES,
} from "../../../managers/TableManger";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import { Store } from "../../../Redux/Store";
// import { store } from "../../../redux/store";
// import { getRecordsByTable } from "../../../redux/slices/recordSlice";

/*
PROPS
- stepData
- onClose
- onSave
*/

class DocumentSelection extends Component {
  constructor(props) {
    super(props);

    this.data =
      this.props.stepData && this.props.stepData.configuration
        ? this.props.stepData.configuration
        : null;

    this.state = {
      isDocumentListReceived: true,
      canValidate: false,
      needListPicker: false,
      selectedIndex: null,
      data: {
        documentId:
          this.data && this.data.documentId ? this.data.documentId : null,
        title: this.data && this.data.title ? this.data.title : null,
      },
      documentList: [{ title: `Any ${this.getNameOfDocument()} *`, id: null }],
    };
    this.getDocumentList();
  }

  getDocumentList() {
    let nameColumnID = "";
    let tableName = "";
    switch (this.props.stepData.type) {
      case AUTOMATION_TRIGGERS.CAMPAIGN_PUBLISHED:
        tableName = TABLES.CAMPAIGN;
        nameColumnID = TableManger.getColumnId(
          tableName,
          COLUMN_CODE.CAMPAIGN.NAME
        );
        break;
      case AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON:
        tableName = TABLES.FORM;
        nameColumnID = TableManger.getColumnId(
          tableName,
          COLUMN_CODE.FORMS.NAME
        );
        break;
      default:
        break;
    }
    // Store
    //   .dispatch(getRecordsByTable({ tableName }))
    //   .then((res) =>
    //     this.setDocumentList(this.buildItemList(res.payload.data, nameColumnID))
    //   );
  }
  setDocumentList(data) {
    this.setState({
      isDocumentListReceived: true,
      documentList: [...this.state.documentList, ...data.documentList],
      selectedIndex: this.data ? data.selectedIndex : null,
    });
  }
  buildItemList(data, nameColumnID) {
    let formList = [];
    let selectedDocIndex = 0;

    data.forEach((rec, index) => {
      formList.push({
        id: rec._id,
        title: rec.cells[nameColumnID],
      });

      if (rec._id === this.state.data.documentId) {
        selectedDocIndex = index + 1;
      }
    });
    return { documentList: formList, selectedIndex: selectedDocIndex };
  }
  render() {
    return (
      <div className="transparent-background">
        <div
          className="column popup-window"
          style={{ padding: 0, maxWidth: 400, overflowY: "visible" }}
        >
          {this.renderHeader()}
          {this.state.isDocumentListReceived && this.renderBody()}
          {this.state.isDocumentListReceived && this.renderBottom()}
          {!this.state.isDocumentListReceived && this.showLoader()}
        </div>
      </div>
    );
  }

  showLoader() {
    return <DKSpinner className="p-xl align-self-center" />;
  }
  getNameOfDocument() {
    if (this.props.stepData.type === AUTOMATION_TRIGGERS.CAMPAIGN_PUBLISHED) {
      return "Campaign";
    }
    if (this.props.stepData.type === AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON) {
      return "Deal";
    }
    return "Document";
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  renderHeader() {
    return (
      <div className="row justify-content-between pt-s pb-s bg-gray3 p-h-m">
        <DKLabel
          text={`Start workflow when ${this.props.stepData.title}...`}
          className="fw-m"
        />
        <DKButton
          icon={DKIcons.ic_close}
          className=""
          onClick={this.props.onClose}
        />
      </div>
    );
  }

  renderBody() {
    return (
      <div className="column parent-width p-l">
        <DKLabel
          text={`Select a ${this.getNameOfDocument()} for which this workflow will be triggered`}
          className=""
        />
        <div className="mt-l row ">
          <div
            className="row p-h-m fs-m border-radius-m border-m cursor-hand position-relative   "
            style={{ width: "auto", height: 32 }}
            onClick={() => this.setVisibilityOfListPicker(true)}
          >
            <DKLabel
              text={
                this.state.selectedIndex !== null && this.state.documentList
                  ? this.state.documentList[this.state.selectedIndex].title
                  : `Select ${this.getNameOfDocument()}`
              }
              className=""
            />
            <DKIcon src={DKIcons.ic_arrow_down2} className="ic-s ml-s" />
            {this.state.needListPicker && (
              <DKListPicker
                title={this.getListPickerTitle()}
                className="position-absolute shadow-m border-m"
                data={
                  this.state.documentList
                    ? this.state.documentList.map((obj) => obj.title)
                    : []
                }
                width={200}
                onClose={() => this.setVisibilityOfListPicker(false)}
                onSelect={(index, value) => {
                  this.setState({ selectedIndex: index });
                  this.dataChanged(
                    this.state.documentList[index].id,
                    "documentId"
                  );
                  this.dataChanged(value, "title");
                  setTimeout(() => {
                    this.setVisibilityOfListPicker(false);
                  }, 10);
                }}
                button={this.getListPickerAddButton()}
              />
            )}
          </div>
        </div>
        {this.state.selectedIndex === null &&
          this.state.canValidate === true && (
            <DKLabel
              text={`Select ${this.getNameOfDocument()} to proceed`}
              className="text-red mt-s ml-xs"
            />
          )}
      </div>
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  getListPickerTitle() {
    if (this.props.stepData.type === AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON) {
      return "Select Form";
    }
    if (this.props.stepData.type === AUTOMATION_TRIGGERS.CAMPAIGN_PUBLISHED) {
      return "Select Campaign";
    }
  }
  getListPickerAddButton() {
    if (this.props.stepData.type === AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON) {
      return {
        title: "+ Add Deal",
        className: "bg-button text-white",
        onClick: () =>
          RouteManager.navigateToPage(PAGE_ROUTES.SELECT_FORM_TEMPLATE),
      };
    }

    if (this.props.stepData.type === AUTOMATION_TRIGGERS.CAMPAIGN_PUBLISHED) {
      return {
        title: "+ New Campaign",
        className: "bg-button text-white",
        onClick: () =>
          RouteManager.navigateToPage(PAGE_ROUTES.SELECT_CAMPAIGN_TEMPLATE),
      };
    }
    return null;
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  setVisibilityOfListPicker(visible) {
    this.setState({ needListPicker: visible });
  }

  renderBottom() {
    return (
      <div className="row-reverse pb-l p-h-m">
        <DKButton
          title="Save"
          className="bg-button text-white ml-m"
          onClick={() => {
            if (this.state.selectedIndex !== null) {
              this.props.onSave(this.state.data);
              this.props.onClose();
            } else {
              this.setState({ canValidate: true });
            }
          }}
        />

        <DKButton
          title="Cancel"
          className="bg-gray1 border-m"
          onClick={this.props.onClose}
        />
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////

  dataChanged(newValue, valueKey) {
    let data_new = this.state.data;
    data_new[valueKey] = newValue;
    this.setState({ data: data_new });
  }

  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////
}

export default DocumentSelection;
